<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Disclaimers'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Disclaimers'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'name',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'disclaimers/index',
            deleteItem: 'disclaimers/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/disclaimers/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/disclaimers/add');
        }
    }
};
</script>
